<div appClickOutside (clickOutside)="onClickOutside()" class="menu" id="menu">
  <uni-list align="center" gap="sm" [divider]="true" bullet="none" orientation="horizontal">
    <uni-list-item [position]="showAll ? 'static' : 'relative'" *ngFor="let section of menu; let last = last">
      <ng-container *ngIf="last && (section.name === 'SEGUROS UNIVERSAL' || section.name === 'SEGUROS UNIT'); else sectionLink">
        <button
          class="portal-button"
          (click)="navigateToPortal(section.name)"
          [ngClass]="getButtonClass(section.name)"
          [ngStyle]="{ 'padding-top': '0.7rem' }"
        >
          {{ section.name }}
        </button>
      </ng-container>

      <!-- Enlace para otras secciones normales del menú -->
      <ng-template #sectionLink>
        <button
          class="navigation-section"
          (click)="onSelectSection(section)"
          *ngIf="section.childs?.length; else sectionRouterLink"
          [ngClass]="{ active: selectedSection?.id === section.id, all: showAll }"
          [ngStyle]="{ 'padding-top': '0.7rem' }"
        >
          <h6 uni-heading weight="semibold" [color]="isUnitPortalStyle ? 'primary-unit' : 'primary'">{{ section.name }}</h6>
        </button>
      </ng-template>

      <!-- Enlace router para las secciones que no tienen hijos -->
      <ng-template #sectionRouterLink>
        <a uni-link [routerLink]="section.url" [ngStyle]="{ 'padding-top': '1rem' }">
          <!-- Estilo aplicado aquí -->
          <h6
            uni-heading
            style="text-transform: uppercase"
            weight="semibold"
            [color]="isUnitPortalStyle ? 'primary-unit' : 'primary'"
            [ngStyle]="{ 'padding-top': '0.7rem' }"
          >
            {{ section.name }}
          </h6>
        </a>
      </ng-template>

      <!-- Sección del menú desplegable -->
      <div
        class="sections-container"
        [ngClass]="{ 'sections-container-all': showAll }"
        *ngIf="isMenuOpen && selectedSection?.id === section.id && section.childs?.length"
      >
        <uni-card padding="none">
          <div class="row" *ngIf="!showAll; else showAllTemplate">
            <div class="col-5">
              <div class="menu-sections-container">
                <uni-list bullet="none" gap="none" paddingLeft="6">
                  <uni-list-item>
                    <div class="section-title">
                      <div class="section-title-heading">
                        <h2 uni-heading weight="semibold" [color]="isUnitPortalStyle ? 'primary-unit' : 'primary'">
                          {{ section.name }}
                        </h2>
                      </div>
                      <button (click)="toggleShowAll($event)" class="show-all">
                        <h6 uni-heading weight="normal" [color]="isUnitPortalStyle ? 'info-unit' : 'info'">
                          Ver todas las opciones
                        </h6>
                      </button>
                    </div>
                  </uni-list-item>
                </uni-list>
                <div #scrollContainer class="section-sub-titles">
                  <uni-list bullet="none" gap="none" paddingLeft="6">
                    <uni-list-item *ngFor="let child of section.childs; index as i">
                      <uni-desktop-menu-section
                        [section]="child"
                        (select)="onSelectChild($event, i)"
                        [active]="child.id === selectedChild?.id"
                      ></uni-desktop-menu-section>
                    </uni-list-item>
                  </uni-list>
                </div>
                <button (click)="selectNextChild()" *ngIf="!isLastChildSelected" variant="muted" uni-icon-button>
                  <uni-icon weight="tin" opacity="mid" size="xxl" name="chevron-down"></uni-icon>
                </button>
              </div>
            </div>
            <div class="col-7">
              <div class="section-links-container">
                <uni-list gap="lg" [bullet]="isUnitPortalStyle ? 'info-unit' : 'info'">
                  <uni-list-item *ngFor="let sectionChild of selectedChild.childs">
                    <div class="item-container">
                      <a
                        uni-link
                        animation="fade"
                        [routerLink]="sectionChild.url"
                        [color]="isUnitPortalStyle ? 'primary-unit' : 'primary'"
                      >
                        {{ sectionChild.name }}
                      </a>

                      <span class="new d-none">Nuevo</span>
                    </div>
                  </uni-list-item>
                </uni-list>
              </div>
            </div>
          </div>

          <ng-template #showAllTemplate>
            <app-desktop-menu-all-options
              (hide)="toggleShowAll($event)"
              [menuSections]="section.childs"
            ></app-desktop-menu-all-options>
          </ng-template>
        </uni-card>
      </div>
    </uni-list-item>
  </uni-list>
</div>
